import Vue from 'vue';
import './bootstrap.js';
import VueProgressBar from 'vue-progressbar';
import VueSlideBar from 'vue-slide-bar'
import VuejsDialog from 'vuejs-dialog';
import vueCountryRegionSelect from 'vue-country-region-select'
import vSelect from 'vue-select';
import store from './store';

import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);

axios.defaults.baseURL = window.apiBaseUrl;
/**
 * Intercept API request and change the access token if the API V2 is used.
 * The API V2 access token is stored in localStorage with a key named `authorization` after user login
 */
axios.interceptors.request.use(
    request => {
        if (request.url.includes('v2/')) {
            let token = localStorage.getItem('authorization');
            request.headers['Authorization'] = 'Bearer ' + token;
        }
        return request;
    }
);

import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
Vue.use(Datetime)
Vue.component('datetime', Datetime);

import { ToggleButton } from 'vue-js-toggle-button'
Vue.component('ToggleButton', ToggleButton)

import Routes from '@/routes.js';
import App from '@/pages/App';

const options = {
    color: '#bffaf3',
    failedColor: '#874b4b',
    thickness: '2px',
    transition: {
        speed: '1s',
        opacity: '0.6s',
        termination: 500
    },
    autoRevert: true,
    location: 'top',
    inverse: false
};

Vue.use(VueProgressBar, options);
Vue.use(VuejsDialog);
Vue.use(vueCountryRegionSelect);
Vue.component('v-select', vSelect);
Vue.component('VueSlideBar', VueSlideBar);

import 'pretty-checkbox/src/pretty-checkbox.scss';
import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);

/** numeric keypad
 * https://github.com/brucejcw/vue-numkeyboard
 */
import numkeyboard from 'vue-numkeyboard';
import 'vue-numkeyboard/style.css';
Vue.use(numkeyboard);


Vue.router = Routes;
Vue.use(require('@websanova/vue-auth'), {
    auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
    http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    rolesVar: 'role',
    loginData: {redirect: ''}
});
App.router = Vue.router;

let VueApp = new Vue({
    el: '#app',
    router: Routes,
    store,
    render: h => h(App),
})

import ezy from './pages/Tools/ezyFunction';
import $Loading from './pages/Tools/loading';
import Fabric from './pages/Tools/Fabric';
import ProductOrder from './pages/Tools/ProductOrder';
import Swal from 'sweetalert2';
import moment from 'moment';
import VueGlobalVar from 'vue-global-var';
import shirtOrderStatus from './pages/Tools/ShirtOrderStatuses';

global.ezy = ezy;
global.Swal = Swal;
global.moment = moment;
global.VueApp = VueApp;
global.$Fabric = Fabric;
global.$ProductOrder = ProductOrder;
global.$Loading = $Loading;
global.shirtOrderStatus = shirtOrderStatus;

Vue.use(VueGlobalVar, {
    globals: {
        ezy,
        moment,
        $Fabric,
        $ProductOrder,
        $Loading,
        shirtOrderStatus
    },
});

export default VueApp;
